import type { Entity, EntityMap } from './types';

/**
 * Update the properties of a fulfilled entity.
 */
type Update = <T extends Entity>(state: EntityMap<T>, id: Entity['id'], newValues: Partial<T>) => EntityMap<T>;
export const update: Update = (state, id, newValues) => {
  if (!state.fulfilled.byId[id]) {
    return state;
  }
  const oldValues = state.fulfilled.byId[id];
  const entry = {
    ...oldValues,
    ...newValues,
  };

  return {
    ...state,
    fulfilled: {
      ...state.fulfilled,
      byId: {
        ...state.fulfilled.byId,
        [id]: entry,
      },
    },
  };
};
